<template>
  <div class="loader">
    <div class="loader-inner">
      <div class="loader-animation">

      </div>
    </div>
  </div>
</template>

<script setup>
  import { useAppStore } from '@/stores/app'
  const appStore = useAppStore()
</script>

<style lang="scss">
  @import '@/assets/scss/global.scss';

  .loader {
    z-index: 9999999;
    background-color: transparent;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    // display: none;

    &.activated {
      background-color: transparent;
    }

    &-inner {
      @include wlx_mixin_center(absolute);
      // Add a subtle backdrop to make the loader icon more visible
      padding: 1rem;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    }

    &-animation {
      width: 45px;
      aspect-ratio: .75;
      --violet: no-repeat linear-gradient(#712154 0 0);
      --orange: no-repeat linear-gradient(#FE8022 0 0);
      --yellow: no-repeat linear-gradient(#FFCB0D 0 0);
      background:
        var(--violet) 0%   50%,
        var(--orange) 50%  50%,
        var(--yellow) 100% 50%;
      animation: l7 1s infinite linear alternate;

    }
  }
  @keyframes l7 {
    0%  {background-size: 20% 50% ,20% 50% ,20% 50% }
    20% {background-size: 20% 20% ,20% 50% ,20% 50% }
    40% {background-size: 20% 100%,20% 20% ,20% 50% }
    60% {background-size: 20% 50% ,20% 100%,20% 20% }
    80% {background-size: 20% 50% ,20% 50% ,20% 100%}
    100%{background-size: 20% 50% ,20% 50% ,20% 50% }
  }
</style>
